import { ConfigurationOntologyForAutomaticAssayResponse } from '@/modules/configurationModule/detail/automation/assays/services/configuration-ontology-for-automatic-assay/configuration-ontology-for-automatic-assay.dto'
import { Nullable } from '@/shared/types/app.types'

export enum ConfigurationAutomationAssaysModalTabIndex {
    BASIC = 0,
    ASSAYS = 1
}

export interface ConfigurationAutomationAssaysModalState {
    ontologyForAutomaticAssay: Nullable<Partial<ConfigurationOntologyForAutomaticAssayResponse>>
    showAssaysTab: boolean
    activeTabIndex: number
}
export const initialConfigurationAutomationAssaysModalState =
    (): ConfigurationAutomationAssaysModalState => ({
        ontologyForAutomaticAssay: {},
        showAssaysTab: false,
        activeTabIndex: ConfigurationAutomationAssaysModalTabIndex.BASIC
    })
